import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import { buildPageContextFields, buildPromptFields } from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';

export function trackPromptClick({ promptText, pageContext = {} }) {
    if (!promptText) {
        return;
    }

    const eventName = EVENT_NAMES.PROMPT_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(promptText)
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        },
        finishEventWithoutTimeout: true
    });
}

export function trackFollowUpClick({ followUpText, pageContext = {}, messageId, previousMessageId }) {
    if (!followUpText) {
        return;
    }

    const eventName = EVENT_NAMES.FOLLOW_UP_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(followUpText, messageId, previousMessageId)
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}
